import { create } from 'zustand'
import { apiFetch } from '../utils/api'

const useSeccionesStore = create((set,get) => ({
    isLoading: true,
    secciones: [],
    iniciar: async() => {
      if (localStorage.getItem('isLoggedIn') === 'true' && localStorage.getItem('auth_token')) {
          try {
            const data = await apiFetch("/api/secciones");
            if (data.status) {
              set({secciones: data.data});
            }
          } catch (error) {
            console.error('Error al cargar secciones:', error);
          }
      }
    }
}))
  
export default useSeccionesStore